/// <reference types="vite/client" />

import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker.js?worker';
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker.js?worker';

const monacoEnvironment = {
  getWorker(_workerId: string, label: string) {
    if (label === 'json') {
      return new JsonWorker();
    }
    return new EditorWorker();
  },
};

Object.assign(globalThis, { MonacoEnvironment: monacoEnvironment });

loader.config({ monaco });

interface JsonLanguageContribution {
  jsonDefaults: {
    setDiagnosticsOptions: (options: {
      validate: boolean;
      allowComments: boolean;
      trailingCommas: 'ignore' | 'warning' | 'error';
      enableSchemaRequest: boolean;
    }) => void;
  };
}

void loader.init().then((monacoApi) => {
  const jsonContribution = (
    monacoApi.languages as unknown as { json: JsonLanguageContribution }
  ).json;

  jsonContribution?.jsonDefaults?.setDiagnosticsOptions({
    validate: true,
    allowComments: false,
    trailingCommas: 'error',
    enableSchemaRequest: false,
  });
});
